import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Bonaire: Country = {
    identifier: "Bonaire",
    name: "Bonaire",
    countryCode: "BQ",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: false,
    flag: "🇧🇶",
    svgPath: "m 283.47675,428.8064 -0.136,0.321 -0.078,-0.143 -0.014,-0.255 -0.056,-0.1 -0.116,-0.061 -0.063,-0.084 0.005,-0.126 0.42,0.202 0.038,0.246 z m 14.785,-15.444 -0.068,0.061 -0.06,-0.005 -0.04,-0.059 -0.007,-0.098 0.057,0.027 0.021,0.015 0.018,0.02 0.079,0.039 z m -0.828,-0.373 -0.025,0.011 -0.036,-0.027 0.006,-0.048 0.03,-0.02 0.023,0.014 0.018,0.038 -0.016,0.032 z",
}
